<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-form-input
          v-model="searchHospitalNameInput"
          placeholder="ค้นหาสถานพยาบาล"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          striped
          hover
          small
          fixed
          responsive
          :items="hospitalList"
          selectable
          select-mode="single"
          class="text-left"
          thead-class="hidden_header"
          :fields="fields"
          @row-selected="rowSelected"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "StatHospitalListComponent",
    computed: {
      ...mapGetters({
        'hospitals': 'Hospital/getAll'
      }),
      hospitalSelectedHandler: {
        get() {
          return this.hospitalSelected
        },
        set(value) {
          this.$emit('update:hospitalSelected', value)
        }
      },
    },
    props: {
      hospitalSelected: {
        required: true
      }
    },
    mounted() {
      this.hospitalList = this.hospitals
    },
    data() {
      return {
        fields: ['name'],
        searchHospitalNameInput: "",
        hospitalList: [],
        hospitalSearchList: []
      }
    },
    methods: {
      ...mapActions({
        'getHospital': 'Hospital/searchHospital'
      }),
      rowSelected(items) {
        this.hospitalSelectedHandler = items
      }
    },
    watch: {
      async searchHospitalNameInput (newValue, oldValue) {
        if (newValue === '') {
          this.hospitalList = this.hospitals
        }  else {
          this.hospitalList = await this.getHospital({
            name: newValue
          })
        }
        this.hospitalSelectedHandler.filter(hospital => this.hospitalList.includes(hospital))
      }
    }
  }
</script>

<style>
.hidden_header {
    display: none;
}
</style>
